export class SelectDate{
    fulldate:string;
    hours: number;
    ampm:string;
    minutes:string;
}